import React from 'react';
import { useNavigate } from 'react-router-dom';

function StatisticsButton({
    formData,

}) {
    const navigate = useNavigate();
  return (
    <button 
    className=" p-4 py-2 px-6 border bg-purple-700 w-full  sm:w-auto"
    onClick={
        () =>  navigate(`/${formData.title?.toLowerCase().replace(/\s+/g, "-")}/events-series/${formData.id}/statistics`, { replace: true })}>
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M10 2a8 8 0 100 16 8 8 0 000-16zm1 11H9v-2h2v2zm0-4H9V7h2v2z" />
      </svg>
      Statistics
    </button>
  );
}

export default StatisticsButton;